import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class CurrentPageService {
  currentFilter: Map<string, any> = new Map();
  filteredColumns: any[] = [];

  set(current: any, type: any = 'concept') {
    this.currentFilter.set(type, current);
  }

  get(type: any = 'concept') {
    return this.currentFilter.get(type) ?? null;
  }

  reset(type: any = 'concept') {
    this.currentFilter.delete(type);
  }

  formatCurrent(that: any, textFilter: string = '') {
    const current: any = {
      configPagination: {
        currentPage: that.configPagination.currentPage,
        firstElement: that.configPagination.firstElement
      },
      order: {
        orderBy: that.orderBy,
        filterOrder: that.filterOrder,
      },
      mainTextFilter: textFilter,
      textFilterNames: [],
      textFilters: {},
      listFilterNames: [],
      listFilters: {},
      hasFilters: false
    }

    current.listFilterNames = that.listFilterNames;
    current.textFilterNames = that.textFilterNames;

    // list filters
    current.listFilterNames.forEach((filter: string) => {
      if (!that[filter + 'ListFilter'].length) {
        return;
      }
      current.hasFilters = true;
      current.listFilters[filter + 'List'] = that[filter + 'List'];
      current.listFilters[filter + 'ListFilter'] = that[filter + 'ListFilter'];
    });

    // search filters
    current.textFilterNames.forEach((filter: string) => {
      current.textFilters[filter + 'SearchFilter'] = that[filter + 'SearchFilter'];
      if (that[filter + 'SearchFilter'].length) {
        current.hasFilters = true;
      }
    });

    return current;
  }

  setFilteredColumns(columns: any) {
    this.filteredColumns = columns;
  }

  getFilteredColumns() {
    return this.filteredColumns;
  }
}